import { createAsyncThunk } from '@reduxjs/toolkit';
import { UploadFileService } from '../../../epics/common/uploadFile';
import {
    deleteImageKey,
    deleteImagesKey,
    getImagesKey,
    imageUploadKey,
} from '../thunkKeys/commonThunksKeys';

export const uploadFile = createAsyncThunk(
    imageUploadKey,
    async (payload, thunkAPI) => {
        try {
            return await UploadFileService.uploadFile(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const deleteImage = createAsyncThunk(
    deleteImageKey,
    async (payload, thunkAPI) => {
        try {
            return await UploadFileService.deleteImage(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const deleteImages = createAsyncThunk(
    deleteImagesKey,
    async (payload, thunkAPI) => {
        try {
            return await UploadFileService.deleteImages(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const getImages = createAsyncThunk(
    getImagesKey,
    async (payload, thunkAPI) => {
        try {
            return await UploadFileService.getImages(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
